// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"f77f8afc","290":"2ae3da82","358":"017b9884","428":"e4daafdb","672":"1882e79a"}[chunkId] + ".chunk.js";
};